module.exports = __webpack_public_path__ + "static/media/table-settings.9fd2a352.svg";